import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Unanimous from '../views/Unanimous.vue'
import Professor from '../views/Professor.vue'
import Member from '../views/Member.vue'
import Member_year from '../views/Member/_year.vue'
import Equipment from '../views/Equipment.vue'
import Research from '../views/Research.vue'
import Published from '../views/Published.vue'
import Papers from '../components/Papers.vue'
import Seminar from '../components/Seminar.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/unanimous',
    name: 'Unanimous',
    component: Unanimous
  },
  {
    path: '/professor',
    name: 'Professor',
    component: Professor
  },
  {
    path: '/member',
    name: 'Member',
    component: Member
  },
  {
    path: '/member/:year',
    name: 'Member_year',
    component: Member_year
  },
  {
    path: '/equipment',
    name: 'Equipment',
    component: Equipment
  },
  {
    path: '/research',
    name: 'Research',
    component: Research
  },
  {
    path: '/published',
    name: 'Published',
    component: Published,
    children:[
      {
        path:'/papers',
        component:Papers
      },
      {
        path:'/seminar',
        component:Seminar
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
